import { render, staticRenderFns } from "./TaxReturnProfessionalActivity.vue?vue&type=template&id=6ae6130b&scoped=true"
import script from "./TaxReturnProfessionalActivity.vue?vue&type=script&lang=js"
export * from "./TaxReturnProfessionalActivity.vue?vue&type=script&lang=js"
import style0 from "./TaxReturnProfessionalActivity.vue?vue&type=style&index=0&id=6ae6130b&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ae6130b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/ovilla/Documents/strappberry/catara-server/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6ae6130b')) {
      api.createRecord('6ae6130b', component.options)
    } else {
      api.reload('6ae6130b', component.options)
    }
    module.hot.accept("./TaxReturnProfessionalActivity.vue?vue&type=template&id=6ae6130b&scoped=true", function () {
      api.rerender('6ae6130b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/views/components/TaxReturnProfessionalActivity.vue"
export default component.exports